import { MoreOutlined } from '@ant-design/icons';
import { List } from 'antd';
import { withMoreMenu } from './HOCs/WithMoreMenu';
import { withPagination } from './HOCs/WithPagination';

/* eslint-disable import/prefer-default-export */
export { default as SelectJobType } from './SelectJobType';
export { default as SelectCategoryWithModal } from './SelectCategory';
export const MoreMenu = withMoreMenu(MoreOutlined);
export const ListWithPagination = withPagination(List);
export * from './FormFields';
export * from './Toolbar';
export * from './Image';
export * from './SwitchMode';
export * from './Tag';
export * from './Tooltip';
export { default as Status } from './Status';
